import { Download, RotateCcw, Save, Upload } from 'lucide-react';
import React from 'react';

const ControlPanel = ({
  presets,
  savePreset,
  loadPreset,
  deletePreset,
  exportConfig,
  importConfig,
  resetToDefaults,
  errors,
}) => {
  return (
    <div className="p-4 mb-6 rounded-lg bg-gray-50">
      <div className="flex flex-wrap items-center gap-2">
        <button
          onClick={savePreset}
          className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200"
        >
          <Save className="w-4 h-4" />
          Зберегти пресет
        </button>
        <button
          onClick={exportConfig}
          className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-green-700 bg-green-100 rounded hover:bg-green-200"
        >
          <Download className="w-4 h-4" />
          Експорт JSON
        </button>
        <label className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-purple-700 bg-purple-100 rounded cursor-pointer hover:bg-purple-200">
          <Upload className="w-4 h-4" />
          Імпорт JSON
          <input type="file" accept=".json" onChange={importConfig} className="hidden" />
        </label>
        <button
          onClick={resetToDefaults}
          className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-red-700 bg-red-100 rounded hover:bg-red-200"
        >
          <RotateCcw className="w-4 h-4" />
          Скинути
        </button>
      </div>

      {/* Помилки імпорту */}
      {errors.import && <div className="p-2 mt-3 text-sm text-red-600 rounded bg-red-50">{errors.import}</div>}

      {/* Збережені пресети */}
      {presets.length > 0 && (
        <div className="mt-4">
          <h3 className="mb-2 text-sm font-medium text-gray-700">Збережені пресети:</h3>
          <div className="flex flex-wrap gap-2">
            {presets.map((preset) => (
              <div key={preset.id} className="flex items-center gap-1 px-2 py-1 bg-white border rounded">
                <span className="text-sm">{preset.name}</span>
                <button onClick={() => loadPreset(preset)} className="text-xs text-blue-600 hover:text-blue-800">
                  Завантажити
                </button>
                <button
                  onClick={() => deletePreset(preset.id)}
                  className="ml-1 text-xs text-red-600 hover:text-red-800"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ControlPanel;
